<script>
import toasts from "../../mixins/toasts";
import StudentIntersectionModal from "./components/StudentIntersectionModal";

export default Vue.extend({
  mixins: [toasts],
  components: {
    StudentIntersectionModal
  },
  props: {
    schedule: {
      type: [Object],
      required: true
    },
    entries: {
      type: [Array],
      required: true
    }
  },
  data() {
    return {
      isPrinting: false,
      modal: {
        active: false,
        item: null,
        modified: false
      },
      duplicate_modal: {
        active: false,
        item: {},
        modified: false
      },
      groupType: null,
      entriesUpdateList: []
    };
  },
  mounted() {
    this.entriesUpdateList = this.entries;

    let entry = _.find(this.entries, { id: parseInt(this.$route.query.entry) });
    if (entry) {
      let subject = entry.subject;

      switch (subject.type) {
        case "main": {
          let linguistic = _.get(subject, "details.linguistic");
          if (linguistic) {
            this.groupType = `linguistic-${linguistic}`;
          } else {
            this.groupType = "regular";
          }

          if (subject.student_type == "master") {
            this.groupType = subject.student_type;
          }
          break;
        }
        case "department": {
          this.groupType = subject.student_type;
          break;
        }
      }

      this.open(entry);
    }
  },
  methods: {
    remove() {
      let archiving = this.schedule.deleted_at == null;

      this.$dialog.confirm({
        title: `${archiving ? "Архивирование" : "Удаление"} расписания`,
        message: `Вы уверены, что хотите ${
          archiving ? "архивировать" : "удалить"
        } это расписание?`,
        confirmText: `${archiving ? "Архивировать" : "Удалить"} расписание`,
        cancelText: "Отмена",
        type: archiving ? "is-warning" : "is-danger",
        hasIcon: true,
        onConfirm: () => {
          let loading = this.$loading.open();

          axios
            .delete(`/api/schedule/${this.schedule.id}`)
            .then(response => {
              this.toast(
                "success",
                `Расписание было успешно ${
                  archiving ? "архивировано" : "удалено"
                }`
              );
              _.delay(() => {
                window.open(`/schedule`, "_self");
              }, 2000);
            })
            .catch(error => {
              this.toast("error", "@unexpected", error);
              loading.close();
            });
        }
      });
    },
    restore() {
      this.$dialog.confirm({
        title: `Восстановление расписания`,
        message: `Вы уверены, что хотите восстановить это расписание?`,
        confirmText: `Восстановить расписание`,
        cancelText: "Отмена",
        type: "is-success",
        hasIcon: true,
        onConfirm: () => {
          let loading = this.$loading.open();

          axios
            .post(`/api/schedule/${this.schedule.id}/restore`)
            .then(response => {
              this.toast("success", `Расписание было успешно восстановлено`);
              _.delay(() => {
                location.reload();
              }, 2000);
            })
            .catch(error => {
              switch (error.response.status) {
                case 409: {
                  this.toast(
                    "warning",
                    "Расписание для этого курса в этом семестре уже существует"
                  );
                  break;
                }
                default: {
                  this.toast("error", "@unexpected", error);
                }
              }
              loading.close();
            });
        }
      });
    },
    onDuplicateOpen() {
      this.duplicate_modal.item = {
        student_type: this.schedule.student_type,
        enrollment_year: this.$moment().year(),
        semester: this.schedule.semester.number
      };
      this.duplicate_modal.modified = true;

      this.duplicate_modal.active = true;
    },
    onDuplicateClose() {
      this.duplicate_modal.active = false;
    },
    onDuplicateModified(item) {
      this.duplicate_modal.item = item;
      this.duplicate_modal.modified = true;
    },
    onDuplicateSubmit() {
      let loading = this.$loading.open();

      axios
        .post(
          `/api/schedule/${this.schedule.id}/duplicate`,
          this.duplicate_modal.item
        )
        .then(response => {
          _.delay(() => {
            window.open(`/schedule/${response.data.id}`, "_self");
          }, 2000);
        })
        .catch(error => {
          switch (error.response.status) {
            case 409: {
              this.duplicate_modal.modified = false;
              this.toast(
                "warning",
                "Расписание для этого курса в этом семестре уже существует"
              );
              break;
            }
            default: {
              this.toast("error", "@unexpected", error);
            }
          }
          loading.close();
        });
    },
    open(entry) {
      if (this.schedule.deleted_at) {
        return;
      }

      if (_.isObject(entry) || entry === true) {
        // This is schedule entry because it has id
        if (_.has(entry, "id")) {
          this.modal.preset = JSON.parse(JSON.stringify(entry));
          this.$router.replace({
            query: {
              entry: entry.id
            }
          });
        } else {
          let entry = _.last(this.entries);

          if (entry) {
            this.modal.preset = {
              classtime: entry.classtime,
              begin_at: entry.begin_at
            };
          } else {
            this.modal.preset = null;
          }
        }
        this.modal.active = true;
      }
    },
    modified() {
      this.modal.modified = true;
    },
    save() {
      let loading = this.$loading.open();

      this.$refs.form
        .save()
        .then(response => {
          if (response.fresh) {
            this.entriesUpdateList.push(response.entry);
          } else {
            let index = _.findIndex(this.entriesUpdateList, {
              id: response.entry.id
            });

            if (index > -1) {
              this.entriesUpdateList.splice(index, 1, response.entry);
            }
          }
          this.toast(
            "success",
            `Занятие было успешно ${response.fresh ? "добавлено" : "обновлено"}`
          );
          this.close();
          loading.close();
        })
        .catch(error => {
          switch (error.response.status) {
            case 422: {
              let data = error.response.data;
              let errors = data.errors;
              let errorKeys = Object.keys(errors);

              if (errorKeys.length > 0) {
                this.toast("error", errors[errorKeys[0]][0]);
              } else {
                this.toast("error", data.message);
              }
              break;
            }
            case 409: {
              let data = JSON.parse(error.response.data.error);
              switch (data.type) {
                case "group": {
                  this.$refs.studentIntersectionModal.open(
                    data.students,
                    this.schedule.student_type,
                    data.groups
                  );
                  break;
                }
                case "classroom": {
                  this.toast(
                    "warning",
                    "Занятия в этой аудитории на это время уже существуют"
                  );
                  break;
                }
                case "teacher": {
                  this.toast(
                    "warning",
                    "Занятия у данного преподавателя на это время уже существуют"
                  );
                  break;
                }
                default: {
                  this.toast("warning", "Занятия на это время уже существуют");
                }
              }
              break;
            }
            default: {
              this.toast("error", "@unexpected", error);
            }
          }

          this.modal.modified = false;
          loading.close();
        });
    },
    deleteEntry() {
      this.$dialog.confirm({
        title: `Удаление занятия`,
        message: `Вы уверены, что хотите удалить это занятие?`,
        confirmText: `Удалить занятие`,
        cancelText: "Отмена",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          let loading = this.$loading.open();

          this.$refs.form
            .delete()
            .then(id => {
              let index = _.findIndex(this.entriesUpdateList, {
                id: id
              });

              if (index > -1) {
                this.entriesUpdateList.splice(index, 1);
              }

              loading.close();
              this.toast("success", `Занятие было успешно удалено`);
              this.close();
            })
            .catch(error => {
              loading.close();
              this.toast("error", "@unexpected", error);
              this.close();
            });
        }
      });
    },
    close() {
      this.modal.active = false;
      this.$router.replace({
        query: null
      });
    },
    print() {
      this.isPrinting = true;
      this.$nextTick(() => {
        window.print();
        this.isPrinting = false;
      });
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/schedule/Show.vue